/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable security/detect-object-injection */
import React, {
    useCallback, useEffect, useState
} from 'react';
import _ from 'lodash';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import { PremierConstants } from 'premier-constant-service';
import { useUpdateSubmissionServices, validationUtil } from 'premier-capability-hooks';
import moment from 'moment';
import metadata from './EventLiabilityPage.metadata.json5';
import styles from '../../SPEventLiabilityStyles.module.scss';
import ProductsCoverageSelectionComponent from '../../components/EventLiability/ProductsCoverageSelection/ProductsCoverageSelectionComponent';
import EventInformationComponent from '../../components/EventLiability/EventInformation/EventInformationComponent'
import UnderwritingInformationComponent from '../../components/EventLiability/UnderwritingInformation/UnderwritingInformationComponent';

function EventLiabilityPage(props) {

    const { wizardData: submissionVM, updateWizardData } = props;
    const { updateSubmission } = useUpdateSubmissionServices();
    const { lineName } = PremierConstants;
    const [isError, setIsError] = useState(false);

    const {
        onValidate,
        initialValidation
    } = useValidation('EventLiabilityPage');
    

    useEffect(() => {

    }, []);

    const onNext = useCallback(
        async () => {     
            const errorEndDate = _.find(submissionVM.value.lobData.speLinLine.coverables.eventLiaCoverable.eventInformation.pslspeEveInfEveLoc, (envLoc) => moment(envLoc.endDatTimOfEve).isBefore(moment(envLoc.staDatTimOfEve)))

            if(!_.isUndefined(errorEndDate)) {
                setIsError(true)

                return false
            }

            setIsError(false)
            
            const {productCode} = submissionVM.value.baseData;
            const lobLineName = lineName[productCode];

            submissionVM.value = await updateSubmission(lobLineName, 'EventLiabilityPage', submissionVM);

            return submissionVM;

        },
        [submissionVM, updateSubmission]
    );

    const onSave = useCallback(
        async () => {
          const subVMCopy = _.clone(submissionVM);
          const productCode = _.get(subVMCopy.value, 'baseData.productCode');

          validationUtil.unSetIsValidationReqFlag(subVMCopy.lobData.speLinLine.coverables.eventLiaCoverable.value, ' ');

          const lobLineName = productCode ? lineName[productCode] : '';

          await updateSubmission(lobLineName, 'EventLiabilityPage', subVMCopy);
               
          return submissionVM;
        },
        [submissionVM]
      );

    const overrideProps = {
        errorNotification: {
            visible: isError
        },
        productCoverageSelectionComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.speLinLine.coverables.eventLiaCoverable.productCoverageSelection"
        },
        eventInformationComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.speLinLine.coverables.eventLiaCoverable.eventInformation"
        },
        underwritingInformationComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.speLinLine.coverables.eventLiaCoverable.underwritingInformation"
        }        
    }

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            productCoverageSelectionComponent: ProductsCoverageSelectionComponent,
            eventInformationComponent: EventInformationComponent,
            underwritingInformationComponent: UnderwritingInformationComponent,
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps),
        [metadata.pageContent, submissionVM, overrideProps]
    );

    const isDisableNext = () => !_.isUndefined(submissionVM.lobData) &&
        !submissionVM.lobData.speLinLine.coverables.eventLiaCoverable.aspects.subtreeValid

    return (
        <WizardPage onNext={onNext} onSave={onSave} skipWhen={initialValidation}
            disableNext={isDisableNext()}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                onModelChange={updateWizardData}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}                
            />
        </WizardPage>
    );
}

EventLiabilityPage.propTypes = wizardProps;
export default withRouter(EventLiabilityPage);
